import React from 'react';
import { useLanguage } from '../Context/LanguageContext';

const LoadingSpinner = ({ title, message, color, children }) => {
  const { t } = useLanguage();
  const loaderColor = color || 'var(--primary)';

  // Keyframes for animations
  const animations = `
    @keyframes pulse-dot {
      0%, 100% {
        transform: scale(1);
        opacity: 0.7;
      }
      50% {
        transform: scale(1.5);
        opacity: 1;
      }
    }

    @keyframes gradient-shift {
      0%, 100% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
    }
  `;

  return (
    <>
      <style>{animations}</style>
      <div
        className='d-flex justify-content-center align-items-center'
        style={{
          minHeight: '100vh',
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          backgroundSize: '400% 400%',
          animation: 'gradient-shift 15s ease infinite'
        }}
      >
        {/* Content container wrapper - includes main card and any children below */}
        <div
          style={{
            padding: '1rem',
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px'
          }}
        >
          {/* Main loading card */}
          <div
            className='p-5 transition-all text-center'
            style={{
              background: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              borderRadius: '24px',
              padding: '3rem 4rem',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.06)'
            }}
          >
            {/* Modern animated dots loader */}
            <div
              className='mb-4'
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px'
              }}
              role='status'
              aria-label={title || t('components.loadingspinner.loadingDefault')}
            >
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: loaderColor,
                  animation: 'pulse-dot 1.4s ease-in-out infinite',
                  animationDelay: '0s'
                }}
              />
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: loaderColor,
                  animation: 'pulse-dot 1.4s ease-in-out infinite',
                  animationDelay: '0.2s'
                }}
              />
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: loaderColor,
                  animation: 'pulse-dot 1.4s ease-in-out infinite',
                  animationDelay: '0.4s'
                }}
              />
            </div>

            <h4
              style={{
                fontFamily: 'var(--font-primary)',
                fontWeight: 600,
                color: loaderColor,
                marginBottom: '0.5rem'
              }}
            >
              {title || t('components.loadingspinner.loadingDefault')}
            </h4>
            <p
              style={{
                color: '#6c757d',
                marginBottom: 0,
                fontFamily: 'var(--font-secondary)'
              }}
            >
              {message || t('components.loadingspinner.defaultMessage')}
            </p>
          </div>

          {/* Render children below the main card if provided */}
          {children && (
            <div style={{ width: '100%', maxWidth: '600px' }}>
              {children}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LoadingSpinner;
